module.exports = __webpack_public_path__ + "img/web.80418660.svg";